import MyInvestmentsAnalysis from './container';

export default MyInvestmentsAnalysis;
